module.exports = __webpack_public_path__ + "static/img/Game.59bcd11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobizone/imgs/browse/Game.jpg
// module id = 1558
// module chunks = 0